/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_Herogame1Inputs */

const id_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game utama`)
};

const ms_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan hero`)
};

const da_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helte-spil`)
};

const de_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helden-Spiel`)
};

const en_us2_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hero game`)
};

const es_es2_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego destacado`)
};

const es_mx2_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego destacado`)
};

const fil_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hero game`)
};

const fr_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu vedette`)
};

const it_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioco eroe`)
};

const hu_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiemelt játék`)
};

const nl_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Helden game`)
};

const no_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heltespill`)
};

const pl_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gra bohatera`)
};

const pt_br2_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo de herói`)
};

const pt_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo de destaque`)
};

const ro_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocul erou`)
};

const fi_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sankaripeli`)
};

const sv_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hjältespel`)
};

const vi_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game nổi bật`)
};

const tr_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öne çıkan oyun`)
};

const cs_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní hra`)
};

const bg_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Геройска игра`)
};

const ru_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главная игра`)
};

const uk_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гра-герой`)
};

const ar_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللعبة المميزة`)
};

const hi_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हीरो गेम`)
};

const th_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมหลัก`)
};

const ja_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒーローゲーム`)
};

const zh_cn2_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代表游戏`)
};

const zh_hant1_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代表遊戲`)
};

const ko_profile_hero_herogame1 = /** @type {(inputs: Profile_Hero_Herogame1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대표 게임`)
};

/**
* | output |
* | --- |
* | "Hero game" |
*
* @param {Profile_Hero_Herogame1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_herogame1 = /** @type {((inputs?: Profile_Hero_Herogame1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_Herogame1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_herogame1(inputs)
	if (locale === "ms") return ms_profile_hero_herogame1(inputs)
	if (locale === "da") return da_profile_hero_herogame1(inputs)
	if (locale === "de") return de_profile_hero_herogame1(inputs)
	if (locale === "en-US") return en_us2_profile_hero_herogame1(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_herogame1(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_herogame1(inputs)
	if (locale === "fil") return fil_profile_hero_herogame1(inputs)
	if (locale === "fr") return fr_profile_hero_herogame1(inputs)
	if (locale === "it") return it_profile_hero_herogame1(inputs)
	if (locale === "hu") return hu_profile_hero_herogame1(inputs)
	if (locale === "nl") return nl_profile_hero_herogame1(inputs)
	if (locale === "no") return no_profile_hero_herogame1(inputs)
	if (locale === "pl") return pl_profile_hero_herogame1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_herogame1(inputs)
	if (locale === "pt") return pt_profile_hero_herogame1(inputs)
	if (locale === "ro") return ro_profile_hero_herogame1(inputs)
	if (locale === "fi") return fi_profile_hero_herogame1(inputs)
	if (locale === "sv") return sv_profile_hero_herogame1(inputs)
	if (locale === "vi") return vi_profile_hero_herogame1(inputs)
	if (locale === "tr") return tr_profile_hero_herogame1(inputs)
	if (locale === "cs") return cs_profile_hero_herogame1(inputs)
	if (locale === "bg") return bg_profile_hero_herogame1(inputs)
	if (locale === "ru") return ru_profile_hero_herogame1(inputs)
	if (locale === "uk") return uk_profile_hero_herogame1(inputs)
	if (locale === "ar") return ar_profile_hero_herogame1(inputs)
	if (locale === "hi") return hi_profile_hero_herogame1(inputs)
	if (locale === "th") return th_profile_hero_herogame1(inputs)
	if (locale === "ja") return ja_profile_hero_herogame1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_herogame1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_herogame1(inputs)
	return ko_profile_hero_herogame1(inputs)
});
export { profile_hero_herogame1 as "profile.hero.heroGame" }